import { updateKeyInStore } from 'App';
import {
  PensionStateValues,
  TCountryPensionTypeRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof PensionStateValues | keyof TCountryPensionTypeRow
>[] = [
  {
    name: 'form5498ReportingIraorRothIraContributionForTaxYear',
    label: 'Form 5498 reporting IRA (or ROTH IRA) contribution for tax year',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.spouseIncome.pension.values.didYouMakeContributionsToAUsIraRothIraOrSepAccountsDuringTheFilingYear',
  },
  {
    name: 'pleaseUploadForm1099ROrSsa1099',
    label: 'Please upload form 1099-R or SSA-1099',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.pension.values.didYouReceiveUsRetirementDistributions',
  },
  {
    name: 'didYouReceiveForeignieNonUsRetirementDistributions',
    label: 'Did you receive Foreign (ie Non-US) retirement distributions?',
    subLabel: () => (
      <p>Such as government/ private pension or disability payments?</p>
    ),
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadSupportingDocumentation',
    label: 'Please upload supporting documentation',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.pension.values.didYouPerformARolloverBetweenTraditionalIraAndRothIra',
  },
];
